// @ vendors
import React from 'react';
import { connect } from 'react-redux';

function withFeatureToggling(WrappedComponent) {
    const BaseWithFeatureToggling = props => {
        return <WrappedComponent {...props} />;
    };

    return connect(state => ({
        flags: state.featureFlagging?.get('data'),
    }))(BaseWithFeatureToggling);
}

export default withFeatureToggling;
